import userApi from './user/api'
import vendorApi from './vendor/api'

const api = {
  ...userApi,
  ...vendorApi,
  getProfileApi(formData) {
    return userApi.getProfileApi(formData)
  },
  getBusinessDetail(formData) {
    return userApi.getBusinessDetail(formData)
  },
  saveUploadPermissions(formData) {
    return userApi.saveViewPermissions(formData)
  }
}

export default api
